import React, { useEffect } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import styles from "../editMedicalCertificate.module.scss";
import classNames from "classnames";
import { getAllPhysician } from "../../../../store/slices/physicianSlice";

const Assigne = ({ medicalCertificateFormData, handleChange }) => {
    const dispatch = useDispatch();
    const { clinicInfo } = useSelector((state) => state.clinic);
    const { physician } = useSelector((state) => state.physician);
    const { token } = useSelector((state) => state.auth);
    const clinicId =clinicInfo[0]?.clinicId || null;
    useEffect(() => {
        dispatch(getAllPhysician({ clinicId, clinicStatus: "Accepted", physicianStatus: "Accepted", token }));
    }, [dispatch, clinicId, token]);

    const medicalStatus = [
        { value: "Medically Fit", label: "Medically Fit" },
        { value: "Medically Unfit", label: "Medically Unfit" },
    ];

    return (
        <div className={classNames(styles.testAndProfile, "card")}>
            <div className="card-body pt-0">
                <div className="row mt-5">
                    <div className="col-md-6 mb-4">
                        <h4 className="mb-3">Doctor :</h4>
                        <Select
                            name="doctor"
                            placeholder="Select Doctor"
                            value={{ value: medicalCertificateFormData?.physicianId, label: medicalCertificateFormData?.physicianName }}
                            onChange={(e) => handleChange(e, "doctor")}
                            options={physician && physician?.map((item) => ({
                                value: item._id,
                                label: item?.userId?.name,
                            }))}
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    maxHeight: "14rem",
                                    overflowY: "auto",
                                }),
                            }}
                        />
                    </div>
                    <div className="col-md-6 mb-4">
                        <h4 className="mb-3">Medical Status :</h4>
                        <Select
                            name="medicalStatus"
                            placeholder="Select Medical Status"
                            value={{ value: medicalCertificateFormData?.medicalStatus, label: medicalCertificateFormData?.medicalStatus }}
                            onChange={(e) => handleChange(e, "medicalStatus")}
                            options={medicalStatus && medicalStatus?.map((item) => ({
                                value: item.value,
                                label: item?.label,
                            }))}
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    maxHeight: "14rem",
                                    overflowY: "auto",
                                }),
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Assigne;